import { CrmOrganisationRelationship } from "../../../../clients/graphqlTypes.js";
import { useTranslate } from "@tolgee/react";

export const RELATIONSHIP_NONE = "none";

export type RelationshipFormValue =
  | CrmOrganisationRelationship
  | typeof RELATIONSHIP_NONE;

/** Seed a form value from a record's nullable relationship (`null` → the `"none"` sentinel). */
export const relationshipToFormValue = (
  crmRelationship: CrmOrganisationRelationship | null | undefined
): RelationshipFormValue => crmRelationship ?? RELATIONSHIP_NONE;

/** Map a form value back to the nullable wire value (the `"none"` sentinel → `null`). */
export const relationshipToModifyInput = (
  value: RelationshipFormValue
): CrmOrganisationRelationship | null =>
  value === RELATIONSHIP_NONE ? null : value;

export const useCrmOrganisationRelationships = () => {
  const { t } = useTranslate(["CrmOrganisations", "OrganisationProfile"]);

  const relationshipOptions: {
    label: string;
    value: CrmOrganisationRelationship | typeof RELATIONSHIP_NONE;
  }[] = [
    {
      label: t("none", {
        ns: "OrganisationProfile",
      }),
      value: RELATIONSHIP_NONE,
    },
    {
      label: t("Partner", {
        ns: "CrmOrganisations",
      }),
      value: "PARTNER",
    },
  ];

  const relationshipLabels: Record<CrmOrganisationRelationship, string> = {
    PARTNER: t("Partner", {
      ns: "CrmOrganisations",
    }),
  };

  // Filtering offers only concrete relationship values (the `relationship` filter
  // is `[CrmOrganisationRelationship!]`); the `"none"` sentinel is edit-only.
  const relationshipFilterOptions: {
    label: string;
    value: CrmOrganisationRelationship;
  }[] = [
    {
      label: t("Partner", {
        ns: "CrmOrganisations",
      }),
      value: "PARTNER",
    },
  ];

  return { relationshipOptions, relationshipLabels, relationshipFilterOptions };
};
